import TrustpilotReview from './TrustpilotReview'

export default TrustpilotReview
